import {
  fork,
  put,
  all,
  takeLatest,
  takeEvery,
  select,
} from "redux-saga/effects";
import isEmpty from "lodash/isEmpty";

import { selectCurrentUserId } from "../store/authSlice";

import { push } from "connected-react-router";

import {
  fetchUsers,
  fetchUser,
  fetchCurrentUser,
  setList,
  setItem,
  addItem,
  updateItem,
  removeItem,
  createUser,
  updateUser,
  deleteUser,
  setCurrentUser,
  setUserActiveFlag,
} from "../store/usersSlice";

import { REQUEST_FAILED } from "../constants/errors";
import { enqueueSnackbarError } from "../store/appSlice";
import { startLoading, setError, setSuccess } from "../store/appSlice";
import * as UsersApi from "../api/Users";
// import * as UsersApi from "../fakeApi/users";
import { callApi } from "./helpers/api";

function* fetchUsersSaga() {
  const operationPath = "users.list";
  yield put(startLoading(operationPath));
  try {
    const data = yield callApi(UsersApi.getUsers);
    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchUserSaga({ payload } = {}) {
  const { id } = payload;

  const operationPath = ["users", "items", id];
  yield put(startLoading(operationPath));

  try {
    const item = yield callApi(UsersApi.getUser, id);
    yield put(
      setItem({
        id,
        item,
      })
    );
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchCurrentUserSaga() {
  const operationPath = "users.current";
  const userId = yield select(selectCurrentUserId);
  yield put(startLoading(operationPath));
  try {
    const data = yield callApi(UsersApi.getUser, userId);
    yield put(setCurrentUser(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* createUserSaga({ payload }) {
  const operationPath = ["users", "create"];
  yield put(startLoading(operationPath));
  try {
    const user = yield callApi(UsersApi.postUser, payload);
    yield put(addItem(user));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/users/${user.id}`));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* updateUserSaga({ payload }) {
  const { data, id } = payload;
  const { newPassword, ...rest } = data;
  let requestPayload;
  if (!isEmpty(newPassword)) {
    requestPayload = data;
  } else {
    requestPayload = rest;
  }

  const operationPath = ["users", "items", id];
  yield put(startLoading(operationPath));
  try {
    const user = yield callApi(UsersApi.patchUser, id, requestPayload);
    yield put(setItem({ id, item: user }));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/users/${user.id}`));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* deleteUserSaga({ payload: id }) {
  try {
    yield callApi(UsersApi.deleteUser, id);
    yield put(removeItem({ id }));
  } catch (error) {
    console.error(error);
    yield put(
      enqueueSnackbarError({
        code: REQUEST_FAILED,
      })
    );
  }
}

function* setUserActiveFlagSaga({ payload }) {
  const { id, value } = payload;
  const operationPath = ["users", "items", id, "setUserActiveFlag"];
  yield put(startLoading(operationPath));
  try {
    const user = yield callApi(UsersApi.patchUser, id, {
      active: value,
    });
    yield put(updateItem({ id, itemPart: { active: user.active } }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchUsers() {
  yield takeLatest(fetchUsers().type, fetchUsersSaga);
}

function* watchFetchUser() {
  yield takeLatest(fetchUser().type, fetchUserSaga);
}

function* watchCreateUser() {
  yield takeEvery(createUser().type, createUserSaga);
}

function* watchUpdateUser() {
  yield takeEvery(updateUser().type, updateUserSaga);
}

function* watchDeleteUser() {
  yield takeEvery(deleteUser().type, deleteUserSaga);
}

function* watchFetchCurrentUser() {
  yield takeEvery(fetchCurrentUser().type, fetchCurrentUserSaga);
}
function* watchSetUserActiveFlag() {
  yield takeLatest(setUserActiveFlag().type, setUserActiveFlagSaga);
}

export default function* rootSaga() {
  yield all([fork(watchFetchUsers)]);
  yield all([fork(watchFetchUser)]);
  yield all([fork(watchCreateUser)]);
  yield all([fork(watchUpdateUser)]);
  yield all([fork(watchDeleteUser)]);
  yield all([fork(watchFetchCurrentUser)]);
  yield all([fork(watchSetUserActiveFlag)]);
}
